import { forwardRef } from "react";
import { Box, BoxProps } from "@mui/material";
import { SxProps } from "@mui/material/styles";
import { Theme } from "@mui/system";
import { useSimpleRichText } from "src/components-mui/common/rich-text/use-simple-rich-text";

// xl is the biggest font-size for text-content
type IFontSizeKeys = "xs" | "sm" | "md" | "lg" | "xl";
export type ISimpleRichTextFontSize = IFontSizeKeys | IFontSizeKeys[];

export interface ISimpleRichTextProps extends BoxProps {
    text: string;
    fontSize?: ISimpleRichTextFontSize;
}

export const SimpleRichText = forwardRef(function SimpleRichText({ text, fontSize, sx, ...boxProps }: ISimpleRichTextProps, ref) {
    const simpleRichTextSx = useSimpleRichText();

    return (
        <Box
            ref={ref}
            fontSize={fontSize}
            sx={{ ...simpleRichTextSx, ...sx } as SxProps<Theme>}
            dangerouslySetInnerHTML={{ __html: text }}
            {...boxProps}
        />
    );
});
